import type {
	ForecastModel,
	SegmentationModel,
	StatusModel,
} from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export type MidTermLineParams = {
	optimizationGroupId: string
	optimizationId: string
	pricingLineId: string
}

export const midTermPredictionQueries = {
	status: () => ({
		queryKey: ['mid-term-prediction', 'status'],
		queryFn: () => client.midTermPrediction.getStatus(),
		staleTime: Infinity,
	}),
	forecast: (params: MidTermLineParams) => ({
		queryKey: ['mid-term-prediction', 'forecast', params],
		queryFn: () => client.midTermPrediction.getForecast(params),
	}),
	segmentation: (params: MidTermLineParams) => ({
		queryKey: ['mid-term-prediction', 'segmentation', params],
		queryFn: () => client.midTermPrediction.getSegmentation(params),
	}),
}

export function useMidTermPredictionStatusQuery<T = StatusModel>(
	options?: UseQueryOptions<StatusModel, Error, T>
) {
	return useQuery<StatusModel, Error, T>({
		...midTermPredictionQueries.status(),
		...(options || {}),
	})
}

export function useMidTermForecastQuery<T = ForecastModel>(
	params: MidTermLineParams,
	options?: UseQueryOptions<ForecastModel, Error, T>
) {
	return useQuery<ForecastModel, Error, T>({
		...midTermPredictionQueries.forecast(params),
		...(options || {}),
	})
}

export function useMidTermSegmentationQuery<T = SegmentationModel>(
	params: MidTermLineParams,
	options?: UseQueryOptions<SegmentationModel, Error, T>
) {
	return useQuery<SegmentationModel, Error, T>({
		...midTermPredictionQueries.segmentation(params),
		...(options || {}),
	})
}
